export async function sendErrorToDiscord(errorMessage, errorStack = null) {
  const webhookURL = process.env.VUE_APP_ERROR_LOG_DISCORD;

  const payload = {
    username: "Error Monitor",
    embeds: [
      {
        title: "🚨 Erro Detectado!",
        description: `**Erro:** ${errorMessage}\n\n**Stack:**\n${errorStack || "Sem stack disponível"}`,
        color: 16711680, // Vermelho
        timestamp: new Date().toISOString(),
      },
    ],
  };

  await fetch(webhookURL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
